module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"replace":"换风格"},"en":{"replace":"Change Style"},"de":{"replace":"Stil ändern"},"es":{"replace":"Cambiar estilo"},"fr":{"replace":"Modifier le style"},"it":{"replace":"Modifica stile"},"jp":{"replace":"スタイルを変更"},"pt":{"replace":"Alterar estilo"},"tw":{"replace":"變更樣式"}}')
  delete Component.options._Ctor
}
